<template>
    <div class="main-body">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "MainBody"
    }
</script>

<style scoped>
    .main-body {
        width: 100%;
        height: 100%;
    }
</style>